import { render, staticRenderFns } from "./IconDialer.vue?vue&type=template&id=a066af72"
var script = {}
import style0 from "./IconDialer.vue?vue&type=style&index=0&id=a066af72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports